import ROUTES from '../routes';
import Statements from "../hoc/statements";
import GLTransaction from '../hoc/statements/transaction/gl';

const StatementsRoutes = {
  path: ROUTES.STATEMENTS_OF_ACCOUNTS,
  element: <Statements />,
  children: [
    {
      path: ROUTES.TRANSACTIONS_GL,
      element: <GLTransaction />,
    },
  ],
};

export default StatementsRoutes;
